import Vue from 'vue'

// 引入弹窗组件
import vDialogs from 'v-dialogs'

// monment 作为全局方法
import moment from 'moment'
import webStorage from 'webStorage'
// animate
import animated from 'animate.css'

import vueWchatTitle from 'vue-wechat-title'

import { targetNewPage } from '../router/routerUtil'

// 百度编辑器
import VueUeditorWrap from 'vue-ueditor-wrap'
Vue.component('vue-ueditor-wrap', VueUeditorWrap)

Vue.use(vDialogs)
Vue.use(vueWchatTitle)
Vue.use(animated)

Vue.prototype.$moment = (t, format) => {
  if (!t) {
    return ''
  }
  if (!format) {
    format = 'YYYY-MM-DD HH:mm:ss'
  }
  // console.log(moment(t).format(format))
  return moment(t).format(format)
}
Vue.prototype.$webStorage = webStorage
Vue.prototype.$targetNewPage = targetNewPage



// WEBPACK FOOTER //
// ./src/components/register.js